// Renders country flag emoji for [data-country-flag] elements (announcement bar country selector)
(function() {
  function isoToFlagEmoji(isoCode) {
    return isoCode
      .toUpperCase()
      .replace(/./g, function(char) {
        return String.fromCodePoint(127397 + char.charCodeAt(0));
      });
  }

  function renderCountryFlags() {
    document.querySelectorAll('[data-country-flag]').forEach(function(element) {
      var isoCode = element.getAttribute('data-country-flag');
      if (isoCode && isoCode.length === 2) {
        element.textContent = isoToFlagEmoji(isoCode);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCountryFlags);
  } else {
    renderCountryFlags();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(renderCountryFlags, 100);
  });
})();

// Aligns announcement bar popovers horizontally with their trigger button (desktop only,
// since the popover is fixed-position and isn't necessarily the right-most element in the bar)
(function() {
  var desktopQuery = window.matchMedia('(min-width: 1000px)');

  function alignPopover(popover) {
    if (!desktopQuery.matches) {
      popover.style.left = '';
      return;
    }
    var container = popover.closest('.popover-container');
    var button = container && container.querySelector('.popover-button');
    if (!button) return;
    var rect = button.getBoundingClientRect();
    var scrollbarClearance = 60;
    popover.style.left = Math.max(8, rect.left - scrollbarClearance) + 'px';
  }

  function observeAnnouncementBarPopovers() {
    document.querySelectorAll('.announcement-bar popover-content').forEach(function(popover) {
      if (popover.dataset.alignObserved) return;
      popover.dataset.alignObserved = 'true';

      new MutationObserver(function() {
        if (popover.hasAttribute('open')) {
          alignPopover(popover);
        }
      }).observe(popover, { attributes: true, attributeFilter: ['open'] });
    });
  }

  window.addEventListener('resize', function() {
    document.querySelectorAll('.announcement-bar popover-content[open]').forEach(alignPopover);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAnnouncementBarPopovers);
  } else {
    observeAnnouncementBarPopovers();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(observeAnnouncementBarPopovers, 100);
  });
})();

// Remembers the country a customer explicitly picks via the country selector (localStorage,
// versioned key), and silently redirects them back to that country if a later page load
// resolves to a different one (e.g. an old bookmark or link to a stale locale-prefixed URL).
// Anchored to the country selector specifically (not the separate language selector, which may
// not even be enabled) since that's the widget this preference is actually tracking.
(function() {
  var PREFERENCE_KEY = 'lg_country_preference_v1';
  var PENDING_KEY = 'lg_selection_pending_v1';
  var REDIRECT_ATTEMPTED_KEY = 'lg_redirect_attempted_v1';
  var LOCALIZATION_FORM_ID = 'announcement-bar-localization-form';
  var COUNTRY_POPOVER_ID = LOCALIZATION_FORM_ID + '-currency';
  // Paths where a silent redirect could disrupt an in-progress flow (e.g. mid-checkout,
  // mid-order-history, mid-cart-review). Matched as path segments, so locale prefixes
  // (e.g. /en-gb/account) still match.
  var REDIRECT_EXCLUDED_PATH_PATTERNS = [/\/account(\/|$)/, /\/checkout(\/|$)/, /\/cart(\/|$)/];

  function isRedirectExcludedPath() {
    var path = window.location.pathname;
    return REDIRECT_EXCLUDED_PATH_PATTERNS.some(function(pattern) {
      return pattern.test(path);
    });
  }

  function markSelectionPending(event) {
    var button = event.target.closest(
      '#' + COUNTRY_POPOVER_ID + ' button[name="country_code"]'
    );
    if (!button) {
      return;
    }
    try {
      sessionStorage.setItem(PENDING_KEY, '1');
    } catch (e) {}
  }

  function syncCountryPreference() {
    var currentCountryInput = document.querySelector(
      '#' + LOCALIZATION_FORM_ID + ' input[name="country_code"]'
    );
    var currentCountry = currentCountryInput && currentCountryInput.value;
    if (!currentCountry) {
      return;
    }

    var justSelected = false;
    try {
      justSelected = sessionStorage.getItem(PENDING_KEY) === '1';
    } catch (e) {}

    if (justSelected) {
      try {
        localStorage.setItem(PREFERENCE_KEY, currentCountry);
        sessionStorage.removeItem(PENDING_KEY);
        sessionStorage.removeItem(REDIRECT_ATTEMPTED_KEY);
      } catch (e) {}
      return;
    }

    if (isRedirectExcludedPath()) {
      return;
    }

    var storedCountry;
    try {
      storedCountry = localStorage.getItem(PREFERENCE_KEY);
    } catch (e) {
      return;
    }

    if (!storedCountry || storedCountry === currentCountry) {
      return;
    }

    var alreadyAttempted = false;
    try {
      alreadyAttempted = sessionStorage.getItem(REDIRECT_ATTEMPTED_KEY) === '1';
    } catch (e) {}
    if (alreadyAttempted) {
      return;
    }

    var matchingButton = document.querySelector(
      '#' + COUNTRY_POPOVER_ID + ' button[name="country_code"][value="' + storedCountry + '"]'
    );
    if (!matchingButton) {
      return;
    }

    try {
      sessionStorage.setItem(REDIRECT_ATTEMPTED_KEY, '1');
    } catch (e) {}

    matchingButton.click();
  }

  document.addEventListener('click', markSelectionPending);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCountryPreference);
  } else {
    syncCountryPreference();
  }
})();
